import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-nav_masterdata",
  "use": "icon-nav_masterdata-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav_masterdata\"><path d=\"M1011.785143 0v1024H73.142857V0h938.642286z m-85.284572 711.094857h-768v227.547429h768v-227.474286z m-128 71.094857v85.357715H627.785143v-85.357715h170.715428z m128-384h-768v227.620572h768V398.189714z m-128 71.168v85.284572H627.785143V469.357714h170.715428z m128-384h-768v227.474286h768v-227.474286z m-128 71.094857v85.357715H627.785143V156.452571h170.715428z\" p-id=\"5659\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol